import PublicReportHeader from 'components/superreports/PublicReportHeader';
import type { WidgetListColumnChange } from 'components/superreports/WidgetList';
import WidgetList from 'components/superreports/WidgetList';
import { Container } from 'components/ui-blocks/container';
import type { CSSProperties } from 'react';
import React from 'react';
import type { FetchHoursForParams } from 'redux/modules/superreports.actions';
import type {
  ReportDraft,
  ReportQuery,
  WidgetMetadataDictionary,
  WidgetWithData,
} from 'redux/modules/superreports.types';
import type { Account } from 'types/account';
import type { UserTimeFormat } from 'types/user';
import type { CostAndDurationSummary } from 'utils/summary';
import PublicReportLiveBanner from './PublicReportLiveBanner';
import styles from './PublicReportView.module.scss';

interface PublicReportViewProps {
  account: Account;
  draft: ReportDraft;
  hideTopBanner?: boolean;
  isLoading: boolean;
  minimumWidgetWidth: number;
  onColumnChange: (a: WidgetListColumnChange) => void;
  onFetchReportHoursFor: (params: FetchHoursForParams) => void;
  query: ReportQuery;
  showMoney?: boolean;
  style?: CSSProperties;
  timestamp?: string;
  totals: CostAndDurationSummary;
  userTimeFormat?: UserTimeFormat;
  widgetMetadata: WidgetMetadataDictionary;
  widgets: Array<WidgetWithData>;
}

const PublicReportView: React.FC<PublicReportViewProps> = ({
  account,
  draft,
  hideTopBanner,
  isLoading,
  query,
  showMoney = true,
  timestamp,
  totals,
  widgets,
  onColumnChange,
  onFetchReportHoursFor,
  widgetMetadata,
  style,
  minimumWidgetWidth,
}) => {
  return (
    <div className={`${styles.container} theme-timely-light`} style={style}>
      {!hideTopBanner && <PublicReportLiveBanner live={!!draft.live} timestamp={timestamp} />}
      <PublicReportHeader
        draft={draft}
        query={query}
        totals={totals}
        account={account}
        showMoney={showMoney}
        minimumWidgetWidth={minimumWidgetWidth}
      />
      <Container className={styles.innerContainer}>
        <WidgetList
          readOnlyWidgets
          readOnlyEntries
          account={account}
          onColumnChange={onColumnChange}
          widgets={widgets}
          isLoading={isLoading}
          onFetchReportHoursFor={onFetchReportHoursFor}
          billedState={query.filters.billed}
          hideEntries={!draft.live || !draft.events}
          totals={totals}
          widgetMetadata={widgetMetadata}
          minimumWidgetWidth={minimumWidgetWidth}
        />
      </Container>
    </div>
  );
};

export default PublicReportView;
